.select {
  block-size: var(--control-height);
  inline-size: 100%;
  min-inline-size: 0;
  padding: 0 var(--space-6) 0 10px;
  border: 1px solid var(--border-control);
  border-radius: var(--radius-control);
  background-color: var(--surface-raised);
  color: var(--text);
  font-size: var(--font-size-13);
}

.select:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: -1px;
  box-shadow: 0 0 0 3px var(--action-soft);
}

.select[aria-invalid="true"] {
  border-color: var(--danger-text);
}

.select:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
